import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { PackageController } from "@shared/src/controllers/route/delivery/package.controller";
import { ShipmentDeliveryController } from "@shared/src/controllers/route/delivery/shipmentdelivery.controller";
import { SecurityController } from "@shared/src/controllers/security/security.controller";
import { PackageInRouteDto } from "@shared/src/dtos/shipment/delivery/PackageInRouteDto";
import { ShipmentDeliveryDto } from "@shared/src/dtos/shipment/delivery/ShipmentDeliveryDto";
import { ShipmentDeliveryLineDto } from "@shared/src/dtos/shipment/delivery/ShipmentDeliveryLineDto";
import { ShipmentController } from "@shared/src/public-api";
import { Subject } from "rxjs-compat";

@Component({
    selector: "shared-shipment-package-card",
    templateUrl: "./shared.shipment.package.card.html",
    styleUrls: ["./shared.shipment.package.card.scss"],
})
export class SharedShipmentPackageCard {

    @Input()
    public readonly: boolean = false;

    pForm: FormGroup;

    public lineChanged = new Subject<PackageInRouteDto>();
    public valueChangedEvent() {
        this.lineChanged.next();
    }

    constructor(
        public shipmentController: ShipmentController,
        public packageController: PackageController,
        public shipmentDeliveryController: ShipmentDeliveryController,
        private fb: FormBuilder,
        @Inject("SecurityController")
        public securityController: SecurityController,
        public dialog: MatDialog,
    ) {

        this.pForm = this.fb.group({
            'packageKey': ['', [Validators.required, Validators.maxLength(255)]],
            'xDimension': [null, Validators.nullValidator],
            'yDimension': [null, Validators.nullValidator],
            'zDimension': [null, Validators.nullValidator],
            'kg': [null, Validators.nullValidator],
            'shipmentDeliveryLine': [null, Validators.required]
        });

    }

    @Output()
    public packageCreated: EventEmitter<PackageInRouteDto> = new EventEmitter<PackageInRouteDto>();

    private _package: PackageInRouteDto;

    @Input()
    public set package(v: PackageInRouteDto) {
        if (this._package === v)
            return;

        this._package = v;
    }

    public get package(): PackageInRouteDto {
        return this._package;
    }

    @Input()
    public shipmentId: number = null;

    public internalDelete: boolean = false;

    removeShipmentDeliveryLineFromPackage(item: ShipmentDeliveryLineDto, index: number) {
        if (!item || !item.packageId)
            return;

        item.packageId = null;

        this.shipmentDeliveryController.modifyShipmentDeliveryLine(item)
            .subscribe((data: ShipmentDeliveryDto) => {
                if (data) {
                    let backLines = data.lines.filter(l => l.shipmentDeliveryLineId == item.shipmentDeliveryLineId);
                    if (backLines && backLines.length > 0) {
                        if (!backLines[0].packageId)
                            this.package.lines.splice(index, 1)

                        if (this.package.lines.length == 0) {
                            this.internalDelete = true;
                            this.package = null;
                        }
                    }
                }
            });
    }

    getResourcePalletCount() {
        if (this.package == null || this.package.lines == null)
            return 0;

        let palletCount = 0;
        this.package.lines.forEach(line => {
            palletCount += line.palletCount;
        });
        return palletCount;
    }

    getResourcePalletType() {

        if (this.package == null || this.package.lines == null || this.package.lines.length == 0)
            return "PALLETTYPES.NONE";

        let palletType = "PALLETTYPES.NONE";
        this.package.lines.forEach(line => {
            palletType = "PALLETTYPES." + line.palletType.toUpperCase();
        });

        return palletType;
    }

    public emptyValue: string = "-";
    pretty(item: any): string {
        return JSON.stringify(item);
    }
}
